export default __webpack_public_path__ + "static/media/slider-img14.5156d593.jpg";